import { createContext, FC, useCallback, useState } from "react";
import useCallToService from "../../../hooks/useCallToService";
import { setQueryFunction } from "../../StandardContextUtils";

type GameMonthlyReportByGameQuery = {
  month: string;
  year: string;
};

type GameMonthlyReportByGameServiceContextProps = {
  query: GameMonthlyReportByGameQuery;
  collection: any[];
  setQuery: (field: string, value: any) => void;
  onFetch: (token?: string) => void;
};

const defaultContext: GameMonthlyReportByGameServiceContextProps = {
  query: {
    month: "",
    year: "",
  },
  collection: [],
  setQuery: (field: string, value: any) => {},
  onFetch: (token?: string) => {},
};
const getServiceEndpoint = () =>
  `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/v1/summary/:agentId/game/monthly/:gameBrand`;
export const GameMonthlyReportByGameServiceContext = createContext(defaultContext);
export const GameMonthlyReportByGameServiceContextProvider: FC<any> = ({ children }) => {
  const [collection, setCollection] = useState([]);
  const [query, setLocalQuery] = useState(defaultContext.query);
  const [callToService] = useCallToService();
  
  const onFetch = useCallback(async () => {
    try {
      const response = await callToService(getServiceEndpoint(), "POST", query);
      if (response.data) setCollection(response.data);
    } catch (error) {
    }
  }, [callToService, query]);
  const setQuery = setQueryFunction(query, setLocalQuery);

  return (
    <GameMonthlyReportByGameServiceContext.Provider
      value={{
        query,
        collection,
        setQuery,
        onFetch,
      }}>
      {children}
    </GameMonthlyReportByGameServiceContext.Provider>
  );
};
